import { FunnelNavigationContext } from "../../../components/funnel/types";
import { apiClient } from "../../../services/axiosInstance";

export enum EventTypes {
  viewed_subscription_offer = "viewed_subscription_offer",
  viewed_registration = "viewed_registration",
  viewed_gift_offer = "viewed_gift_offer",
  app_install_prompt = "app_install_prompt",
  viewed_alc_offer = "viewed_alc_offer",
  viewed_bundle_offer = "viewed_bundle_offer",
  view_offer_paywall = "view_offer_paywall",
}

export function publishAppInstallPromptInteractionEvent(
  action: "open" | "continue" | "dismiss",
) {
  publishEvent({
    event: EventTypes.app_install_prompt,
    action: action,
  });
}
export function publishViewedSubscriptionOfferEvent(
  navigationContext: FunnelNavigationContext,
) {
  publishEvent({
    event: EventTypes.viewed_subscription_offer,
    comic_id: navigationContext.data?.comicId,
    comic_name: navigationContext.data?.comicName,
    release_id: navigationContext.data?.releaseId,
    context_area: navigationContext.contextArea,
    context_referrer: navigationContext.contextReferrer,
  });
}

export function publishViewedAlcOfferEvent(
  navigationContext: FunnelNavigationContext,
) {
  publishEvent({
    event: EventTypes.viewed_alc_offer,
    comic_id: navigationContext.data?.comicId,
    comic_name: navigationContext.data?.comicName,
    release_id: navigationContext.data?.releaseId,
    release_order: navigationContext.data?.releaseOrder,
    context_area: navigationContext.contextArea,
    ppb_price_point: navigationContext.data?.ppbPricePoint,
    ppb_gold_price_point: navigationContext.data?.ppbGoldPricePoint,
    has_subscribe_offer: navigationContext.data?.hasSubscribeOffer,
    premium_only: navigationContext.data?.premiumOnly,
  });
}

export function publishViewedGiftOfferEvent(
  navigationContext: FunnelNavigationContext,
) {
  publishEvent({
    event: EventTypes.viewed_gift_offer,
    comic_id: navigationContext.data?.comicId,
    comic_name: navigationContext.data?.comicName,
    release_id: navigationContext.data?.releaseId,
    context_area: navigationContext.contextArea,
  });
}

export function publishViewedRegistrationEvent(
  navigationContext: FunnelNavigationContext,
) {
  publishEvent({
    event: EventTypes.viewed_registration,
    comic_id: navigationContext.data?.comicId,
    comic_name: navigationContext.data?.comicName,
    release_id: navigationContext.data?.releaseId,
    context_area: navigationContext.contextArea,
    release_order: navigationContext.data?.releaseOrder,
    artist_id: navigationContext.data?.artistId,
  });
}

export function publishViewOfferPaywallEvent(
  navigationContext: FunnelNavigationContext,
) {
  publishEvent({
    event: EventTypes.view_offer_paywall,
    context_area: navigationContext.contextArea,
  });
}

export function publishVideoStartEvent(
  videoCategory: string,
  videoUrl: string,
  articleId: number,
) {
  publishEvent({
    event: "video_start",
    video_category: videoCategory,
    video_url: videoUrl,
    article_id: articleId.toString(),
  });
}

export function publishChatJoinedEvent(roomId: string) {
  publishEvent({
    event: "chat_joined",
    room_id: roomId,
  });
}

export function publishEvent(event: any) {
  return apiClient.post(`/v1/account/publish-event`, {
    meta: {},
    payload: event,
  });
}
